import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { PaginationResult } from '../core/pagination';
import { Report, ReportStatus } from '../models';

@Injectable({ providedIn: 'root' })
export class ReportApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/BackofficeReports`;

  getReports(options?: {
    regions?: string[];
    cities?: string[];
    status?: ReportStatus;
    skip?: number;
    take?: number;
  }) {
    let params = new HttpParams();

    if (options?.regions) {
      params = params.append('regions', options.regions.join(','));
    }

    if (options?.cities) {
      params = params.append('cities', options.cities.join(','));
    }

    if (options?.status) {
      params = params.append('status', options.status);
    }

    if (options?.skip !== null && options?.skip !== undefined) {
      params = params.append('skip', options.skip);
    }

    if (options?.take !== null && options?.take !== undefined) {
      params = params.append('take', options.take);
    }

    return this.http.get<PaginationResult<Report>>(this.baseUrl, { params });
  }

  getReport(id: string) {
    return this.http.get<Report>(`${this.baseUrl}/${id}`);
  }

  createReport(request: {
    contractingAuthorityId: string;
    link: string;
    notes: string;
    attachmentsIds: string[];
  }) {
    return this.http.post<Report>(this.baseUrl, request);
  }

  updateReportStatus(id: string, status: ReportStatus) {
    return this.http.put<Report>(`${this.baseUrl}/status`, {
      reportId: id,
      newStatus: status,
    });
  }

  deleteReport(id: string) {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
